import React from 'react'
import { Provider } from 'react-redux'

import AddOnImpl from 'live/api/add-on'
import liveUiService from 'live/services/ui'
import { axisRendererRegistry } from 'live/services/charts/axis'
import ServiceLocator from 'live/services/service-locator'
import { displayUnitStore } from 'plugin-assets/shared/display-units/displayUnitStore'

import store from '../store'
import './alarm-tooltip.css'
import { AlarmAxis } from './components/AlarmAxis'
import Sideview from './components'

ServiceLocator.getService('plugin-managed-alarms:alarms-service').then(service => {
    const Main = () => (
        <Provider store={store}>
            <Sideview alarmsComponent={service.getAlarmsComponent()} displayUnitStore={displayUnitStore} />
        </Provider>
    )

    liveUiService.registerAddOn(liveUiService.uiSections.DASHBOARD_VIEW_UNDER_HEADER, new AddOnImpl(Main, { order: 1 }))
})

axisRendererRegistry.register(AlarmAxis)
